import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CategoriaFormGroup = ({ fIsSubmitting }) => (
  <Form.Group>
    <Form.Label text='CATEGORÍA' htmlFor='input-categoria' md={4} alignRightAt='md' />
    <Col md={8}>
      <Field name='categoria'>
        {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} id='input-categoria' />}
      </Field>
    </Col>
  </Form.Group>
)

export default React.memo(CategoriaFormGroup)
